import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';
import { CtaButton } from '../styled';

const Container = styled.div`
  padding: 0 25px;
`;

const ValuesGridInner = styled.div`
  max-width: 990px;
  margin: 0 auto;
  border-bottom: 1px solid #f2f2f2;
  border-left: 1px solid #f2f2f2;
`;

const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 32px;
  border-top: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  text-align: center;
`;

const Name = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
`;

const Description = styled.div`
  color: #666666;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
`;

const CtaContainer = styled.div`
  background: #fafbfc;
  display: flex;
  align-items: center;
  height: 175px;
  border-top: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  text-align: center;
`;

const CtaInner = styled.div`
  max-width: 350px;
  padding: 0 25px;
  margin: 0 auto;
`;

const CtaDescription = styled.div`
  color: #1e5cb3;
  padding-bottom: 16px;
  font-size: 16px;
  line-height: 20px;
`;

const RoleCtaButton = styled(CtaButton)`
  background: #1e5cb3;
  color: white;

  &:hover {
    background: #3f81df;
  }

  &:active {
    background: #133a71;
  }
`;

function ValuesGridSection({ input }) {
  return (
    <Container>
      <ValuesGridInner>
        <Grid columns={6} columnGap={'0'} rowGap={'0'}>
          {input.items.map((item, i) => {
            return (
              <Cell key={i} xs={6} sm={2}>
                <ValueContainer>
                  <div>
                    <Name>{item.name.text}</Name>
                    <Description>{item.description.text}</Description>
                  </div>
                </ValueContainer>
              </Cell>
            );
          })}
          <Cell xs={6} sm={6}>
            <CtaContainer>
              <CtaInner>
                <CtaDescription>{input.primary.cta_description.text}</CtaDescription>
                <div>
                  <a href="/careers">
                    <RoleCtaButton type="button">{input.primary.cta_button_label.text}</RoleCtaButton>
                  </a>
                </div>
              </CtaInner>
            </CtaContainer>
          </Cell>
        </Grid>
      </ValuesGridInner>
    </Container>
  );
}

export { ValuesGridSection };
